<template>
  <div class="inner">
    <div class="footer">
      <!-- 友情链接 -->
<!--      <div class="friendLik" >
        <div class="linkLi" v-for="item of linkList" :key="item.VWlinkId">
          <a :href="item.VLine" target="_blank">{{item.VName}}</a>
        </div>
      </div>-->
      <!-- 分割线 -->
<!--       <div class="dividLine"></div>-->
      <!-- 版权 -->
      <div class="copyright">
        <p>{{beian}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { jump, getUser} from '../../untils/auth'
export default {
  props: {
    linkList: Array
  },
  name: 'HomeFooter',
  data() {
    return {
      beian: '',
    }
  },
  created() {
    /*配置表*/
    this.axios.post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=beian").then((res) => {
      if (res.status == 200) {
        console.log(res)
        if (res.data.status == 200) {
          this.beian =res.data.obj[0].VName;
        }
      }
    });
  },
}
</script>
<style>
    .footer {
        color: gray;
        font-size: 0.14rem
    }
    .footer .friendLik {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        padding: 0.1rem 0;
    }
    .footer .friendLik .linkInfo {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: center;
        margin-top: 0.1rem
    }
    .footer .friendLik .linkLi a {
        color: gray;
    }
    .footer .dividLine {
      height: 1px;
      width: 100%;
      background: #CCCCCC;
      opacity: 0.2;
    }
    .copyright {
      text-align: center;
      /*height: 0.6rem;*/
      line-height: 0.3rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/ivew/footer.vue